/* Iceberg */
import { Box, Card, Flex, ProgressBar, Text } from '@auviknetworks/iceberg-ui';

/* MUI */
import { useTheme } from '@mui/material/styles';

/* Hooks */
import { useUserTheme } from 'hooks/dataAccess/User/userTheme';

/* Images */
import { ReactComponent as SearchingAppsAnimationDark } from 'images/searchApps/disco-app-dark.svg';
import { ReactComponent as SearchingAppsAnimationLight } from 'images/searchApps/disco-app-light.svg';

/* React */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const SearchingApps = ({ onDone, progressBarText }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const userTheme = useUserTheme();
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        const timeout = setTimeout(() => {
            onDone();
        }, 10000); // 10 seconds

        const interval = setInterval(() => {
            setCounter((prevCounter) => prevCounter + 1);
        }, 10);

        return () => {
            clearTimeout(timeout);
            clearInterval(interval);
        };
    }, [onDone]);

    return (
        <Flex
            alignItems="center"
            data-testid="searchingApps"
            flexDirection="column"
            width="100%"
        >
            {userTheme === 'light' ? (
                <SearchingAppsAnimationLight />
            ) : (
                <SearchingAppsAnimationDark />
            )}
            <Text fontSize={2} mt={4} textAlign="center" my={4}>
                {progressBarText}
            </Text>
            <Box width="100%" my={2}>
                <ProgressBar
                    backgroundColor={theme.palette.progressBar.backgroundColor}
                    color={theme.palette.progressBar.main}
                    size="sm"
                    max={900} // 900 * 10 from the interval, needed to be shorter than the 10s timeout, otherwise the bar does not fill all the way
                    value={counter}
                />
            </Box>
            <Card width="100%" mt={4} p={3}>
                <Text>{t('SearchingAppsStep.step1')}</Text>
            </Card>
            <Card width="100%" mt={2} p={3}>
                <Text>{t('SearchingAppsStep.step2')}</Text>
            </Card>
            <Card width="100%" mt={2} p={3}>
                <Text>{t('SearchingAppsStep.step3')}</Text>
            </Card>
        </Flex>
    );
};
